import { PaymentPlan, PurchaseTimelineType } from "../../../model/leads/leads";

export const getPurchaseTimelineText = (value: number): string => {
	switch (value) {
		case PurchaseTimelineType.ReadyToBuyNow:
			return "Ready to buy now";
		case PurchaseTimelineType.ReadyToBuyInTheNextThreeMonths:
			return "Ready to buy in the next three months";
		case PurchaseTimelineType.NeedQuotationForAleterDate:
			return "Need quotation for a later date";
		case PurchaseTimelineType.Undefined:
		default:
			return "Unknown";
	}
};
export const getPaymentPlanText = (value: number): string => {
	switch (value) {
		case PaymentPlan.OneTime:
			return "One Time Payment";
		case PaymentPlan.Installment:
			return "Installment Payment";
		case PaymentPlan.PayAsYouGo:
			return "Pay As You Go";
		case PurchaseTimelineType.Undefined:
		default:
			return "Unknown";
	}
};